import { render, staticRenderFns } from "./micro-page-look.vue?vue&type=template&id=2f547d08&scoped=true&"
import script from "./micro-page-look.vue?vue&type=script&lang=js&"
export * from "./micro-page-look.vue?vue&type=script&lang=js&"
import style0 from "./micro-page-look.vue?vue&type=style&index=0&id=2f547d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f547d08",
  null
  
)

export default component.exports